import { Archive, Mail, PenLine, Send, Settings, Trash2, UserRound } from 'lucide-react'
import { NavLink, Outlet } from 'react-router-dom'
import { cn } from '../../lib/cn'
import { useI18n } from '../../i18n'

export function MailLayout() {
  const { t } = useI18n()
  const folders = [
    { to: '/user/mail', label: 'user.inbox', icon: Mail },
    { to: '/user/mail/sent', label: 'user.sent', icon: Send },
    { to: '/user/mail/drafts', label: 'user.drafts', icon: Archive },
    { to: '/user/mail/spam', label: 'user.spam', icon: Archive },
    { to: '/user/mail/trash', label: 'user.trash', icon: Trash2 },
  ]
  return (
    <div className="grid gap-5 lg:grid-cols-[13rem_1fr]">
      <aside className="lg:border-r lg:pr-5">
        <NavLink to="/user/compose" className="btn-primary mb-4 flex items-center justify-center gap-2 w-full">
          <PenLine size={16}/>{t('user.compose')}
        </NavLink>
        <nav className="flex gap-1 overflow-x-auto pb-2 scrollbar-thin lg:flex-col lg:overflow-x-visible lg:pb-0">
          {folders.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} end={to === '/user/mail'} to={to} className={({ isActive }) => cn('nav-link shrink-0', isActive && 'nav-link-active')}>
              <Icon size={16}/>{t(label)}
            </NavLink>
          ))}
          <div className="my-1 hidden border-t lg:block" />
          <NavLink to="/user/contacts" className={({ isActive }) => cn('nav-link shrink-0', isActive && 'nav-link-active')}>
            <UserRound size={16}/>{t('user.contacts')}
          </NavLink>
          <NavLink to="/user/settings" className={({ isActive }) => cn('nav-link shrink-0', isActive && 'nav-link-active')}>
            <Settings size={16}/>{t('user.settings')}
          </NavLink>
        </nav>
      </aside>
      <section className="min-w-0">
        <Outlet />
      </section>
    </div>
  )
}
